import { useEffect, useState } from "react";
import styles from "../styles/style.module.css";
import commonStyles from "../../../lib/common/common.module.css";
import { LOCAL_CONSTANTS } from "../../../lib/constants";
import { UserTypes } from "../../../interfaces";
import { list } from "../api";
import Layout from "../../../ui/layout";
import { Pagination } from "../../../ui";
import moment from "moment";

const LogisticsRequests = () => {
  const [pagination, setPagination] = useState({
    skip: 0,
    limit: LOCAL_CONSTANTS.limitCount,
  });
  const [search, setSearch] = useState<string | null>(null);
  const [startDate, setStartDate] = useState<string>("");
  const [endDate, setEndDate] = useState<string>("");
  const [requests, setRequests] = useState<{ list: any[]; count: number }>({
    list: [],
    count: 0,
  });
  const [loading, setLoading] = useState<boolean>(true);

  const listRequests = () => {
    const query: any = {
      page: 1 + pagination.skip,
      limit: pagination.limit,
    };
    if (search) query.search = search;
    if (startDate) query.startDate = startDate;
    if (endDate) query.endDate = endDate;
    list(query)
      .then((response: any) => {
        const data = response?.data || {};
        const listData = data.data || [];
        const total = data.pagination?.total ?? listData.length;
        setRequests({ list: listData, count: total });
      })
      .catch(() => {
        setRequests({ list: [], count: 0 });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    setLoading(true);
    const debounceSearch = setTimeout(() => {
      listRequests();
    }, 500);
    return () => clearTimeout(debounceSearch);
  }, [pagination.skip, pagination.limit, search, startDate, endDate]);

  const handleResetFilters = () => {
    setSearch("");
    setStartDate("");
    setEndDate("");
    setPagination({
      skip: 0,
      limit: LOCAL_CONSTANTS.limitCount,
    });
    setTimeout(() => setSearch(""), 0);
  };

  return (
    <Layout title="Logistics Requests">
      <div className={commonStyles.tableData}>
        {/* <div className={commonStyles.topFilter}>
          <div className={styles.date_calender}>
            <input
              type="search"
              placeholder="Search by name or email"
              onChange={(e) => setSearch(e.target.value)}
              value={search || ""}
            />
          </div>
          <div className={styles.date_calender}>
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              placeholder="Start Date"
            />
          </div>
          <div className={styles.date_calender}>
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              placeholder="End Date"
            />
          </div>
          <div className={`d-flex gap-3 align-items-center w-50 ${styles.filterSlect}`}>
            <button
              onClick={handleResetFilters}
              className={`mt-4 ${styles.loyalityPointBtn}`}
            >
              Reset
            </button>
          </div>
        </div> */}
        <div className={styles.scrollTable}>
          <table>
            <thead>
              <tr>
                {LOCAL_CONSTANTS.logisticsRequestsTableHeaders?.map(
                  (header: UserTypes.TableHeader) => (
                    <th key={header?.value}>{header?.label}</th>
                  )
                )}
              </tr>
            </thead>
            <tbody>
              {loading && (
                <tr>
                  <td
                    colSpan={LOCAL_CONSTANTS.logisticsRequestsTableHeaders?.length || 10}
                    align="center"
                    className={styles.loadingText}
                  >
                    {LOCAL_CONSTANTS.loading}
                  </td>
                </tr>
              )}
              {!loading && requests.list.length === 0 && (
                <tr>
                  <td
                    colSpan={LOCAL_CONSTANTS.logisticsRequestsTableHeaders?.length || 10}
                    align="center"
                  >
                    No logistics requests found
                  </td>
                </tr>
              )}
              {!loading &&
                requests.list.map((item: any) => (
                  <tr key={item._id}>
                    <td>{item.transId || "N/A"}</td>
                    <td>{item.orderId || "N/A"}</td>
                    <td>{item.status || "N/A"}</td>
                    <td>{item.orderStatus || "N/A"}</td>
                    <td>{item.kycStatus || "N/A"}</td>
                    <td>{item.awbNo || "N/A"}</td>
                    <td>
                      {item.firstName || ""} {item.lastName || ""}
                      {!(item.firstName || item.lastName) && "N/A"}
                    </td>
                    <td>{item.email || "N/A"}</td>
                    <td>{item.phone || "N/A"}</td>
                    <td>
                      {item.createdAt
                        ? moment.utc(item.createdAt).format("DD/MM/YYYY")
                        : "N/A"}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
        <Pagination
          paginationState={pagination}
          setPaginationState={setPagination}
          count={requests.count}
        />
      </div>
    </Layout>
  );
};

export default LogisticsRequests;
